<template>
  <div class="location">
    <div class="relative flex items-center justify-between mb-8 md:mb-16">
      <div>
        <h4 class="module__title">{{ meta.title }}</h4>
        <div class="module__description">{{ meta.description }}</div>
      </div>
      <div v-show="swiperButtonShow" class="hidden md:flex items-center justify-center" style="width: fit-content; gap: 8px">
        <div class="flex items-center justify-center" :class="`swiper-button-prev swiper-button-prev-${cid}`" slot="button-prev">
          <i class="owl-direction-left"></i>
        </div>
        <div class="flex items-center justify-center" :class="`swiper-button-next swiper-button-next-${cid}`" slot="button-next">
          <i class="owl-direction-right"></i>
        </div>
      </div>
    </div>
    <div class="relative">
      <swiper :options="options" :ref="`swiper-location-${cid}`" class="h-full sm:rounded">
        <swiper-slide v-for="(col, index) in meta.content" :key="`locationCard-${index}`">
          <router-link :to="locationRouter(col)" class="location__col__link">
            <locationCard
              :col="col"
              :index="index"
            />
          </router-link>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import locationCard from './components/locationCard'

export default {
  name: 'module_Location',
  props: ['meta'],
  components: {
    locationCard
  },
  data () {
    return {
      // swiper: null,
      cid: this._uid,
      options: {
        loop: false,
        preventInteractionOnTransition: true,
        slideToClickedSlide: false,
        navigation: {
          nextEl: `.swiper-button-next-${this._uid}`,
          prevEl: `.swiper-button-prev-${this._uid}`
        },
        grabCursor: true,
        breakpoints: {
          3000: {
            slidesPerView: 6.2,
            slidesPerGroup: 6.2,
            spaceBetween: 24
          },
          800: {
            slidesPerView: 4.2,
            slidesPerGroup: 4.2,
            spaceBetween: 16
          },
          580: {
            slidesPerView: 3.2,
            slidesPerGroup: 3.2,
            spaceBetween: 16
          },
          430: {
            slidesPerView: 2.2,
            slidesPerGroup: 2.2,
            spaceBetween: 16
          }
        },
        pagination: {
          el: '.swiper-pagination'
        }
      },
      swiperButtonShow: false
    }
  },
  computed: {
    ...mapGetters({
      searchPeople: 'search/people',
      initWidth: 'initWidth'
    }),
    swiper () {
      return this.$refs[`swiper-${this.cid}`].swiper
    }
  },
  methods: {
    ...mapActions([
      'search/setAutoCompleteResult'
    ]),
    locationRouter: function (col) {
      const defaultChildAge = this.searchPeople.childAge.length > 0 ? this.searchPeople.childAge.join(',') : undefined

      return {
        name: 'HotelsList',
        query: {
          search: col.text.slice(-1)[0],
          searchId: col.id.slice(-1)[0],
          start: this.$dayjs().add(6, 'day').format('YYYY-MM-DD'),
          end: this.$dayjs().add(7, 'day').format('YYYY-MM-DD'),
          adult: this.$route.query.adult || this.searchPeople.adult,
          child: this.$route.query.child || this.searchPeople.child,
          ages: this.$route.query.ages || defaultChildAge
        }
      }
    }
  },
  mounted() {
    // console.log('swiper container width', this.$refs[`section-recommend-hotel-${this.cid}`].swiper.width)
    // console.log('all slides width', this.$refs[`section-recommend-hotel-${this.cid}`].swiper.virtualSize)
    this.$nextTick(() => {
      const swiperWidth = this.$refs[`swiper-location-${this.cid}`]?.swiper?.width
      const swiperSlideWidth = this.$refs[`swiper-location-${this.cid}`]?.swiper?.virtualSize
      if (swiperSlideWidth > swiperWidth) {
        this.swiperButtonShow = true
      } else {
        this.swiperButtonShow = false
      }
    })
  }
}
</script>

<style lang="sass" scoped>
.location
  @apply mt-16 mb-16
  min-height: 344px
  @screen md
    @apply -mx-8 mb-32
  &__col
    @apply relative text-center rounded-sm text-white p-8 flex items-center justify-center cursor-pointer
    &__link
      @apply w-full no-underline
    &__cover
      @apply w-full ease
      padding-top: imageRatio(233, 152)
      transform: scale(1.005)
      background:
        position: center
        repeat: no-repeat
        size: cover
      &:hover
        @apply shadow-md
        transform: scale(1.1)
      &__wrap
        @apply overflow-hidden rounded-sm w-full
    &__name
      @apply absolute text-lg font-bold
      bottom: 16px
      left: 16px
      // transform: translate(-50%, -50%)
      text-shadow: 0 0 5px rgba(0, 0, 0, 0.75)
  .location-separate
    &:not(:last-child)
      @apply hidden
      &::after
        content: ' '
</style>
<style lang="sass">
.location
  .swiper-container
    @apply px-16
    @screen sm
      @apply px-0
  .swiper-button-prev, .swiper-button-next
    @apply outline-none #{!important} rounded-full bg-grey-lightest
    position: relative !important
    // padding-top: 4px
    // padding-left: 2px
    background-image: none !important
    width: 35px !important
    height: 35px !important
    margin-top: 0px !important
    // z-index: 8
    i[class*=owl-direction]
      @apply text-grey-darkest
      font-size: 18px
  .swiper-button-prev
    left: initial
  //   right: 0px !important
  //   @screen sm
  //     right: 17.5px !important
  .swiper-button-next
    right: initial
  //   right: 0px !important
  //   @screen sm
  //     right: -17.5px !important
  .swiper-button-disabled
    @apply cursor-not-allowed
</style>
